<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.67912 3.55554H5.3211C3.79379 3.55554 2.55566 4.82904 2.55566 6.39999V25.6C2.55566 27.1709 3.79379 28.4444 5.3211 28.4444H8.67912C10.2064 28.4444 11.4446 27.1709 11.4446 25.6V6.39999C11.4446 4.82904 10.2064 3.55554 8.67912 3.55554Z"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5678 3.55554H14.2098C12.6825 3.55554 11.4443 4.82904 11.4443 6.39999V25.6C11.4443 27.1709 12.6825 28.4444 14.2098 28.4444H17.5678C19.0951 28.4444 20.3332 27.1709 20.3332 25.6V6.39999C20.3332 4.82904 19.0951 3.55554 17.5678 3.55554Z"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.457 3.55554H23.0989C21.5716 3.55554 20.3335 4.82904 20.3335 6.39999V25.6C20.3335 27.1709 21.5716 28.4444 23.0989 28.4444H26.457C27.9843 28.4444 29.2224 27.1709 29.2224 25.6V6.39999C29.2224 4.82904 27.9843 3.55554 26.457 3.55554Z"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="3"
      y1="10.8"
      x2="29"
      y2="10.8"
      stroke="currentColor"
      stroke-width="2.4"
    />
    <line
      x1="6.68867"
      y1="23.1111"
      x2="6.68867"
      y2="19.5555"
      stroke="currentColor"
      stroke-width="2.4"
    />
    <line
      x1="15.5778"
      y1="23.1111"
      x2="15.5778"
      y2="19.5555"
      stroke="currentColor"
      stroke-width="2.4"
    />
    <line
      x1="24.4665"
      y1="23.1111"
      x2="24.4665"
      y2="19.5555"
      stroke="currentColor"
      stroke-width="2.4"
    />
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'SupportBlogIcon',
  });
</script>
